import {NatGetScheduleList} from './NatGetScheduleList'
import {NatPostSchedule, NatPostScheduleParams} from './NatPostSchedule'
import {NatGetSchedule} from './NatGetSchedule'
import {NatPutSchedule, NatPutScheduleParams} from './NatPutSchedule'
import {NatDeleteSchedule} from './NatDeleteSchedule'

import Http from '../../../../network/Http'
import {ContentType} from '../../../../network/Constants';

export default class NatScheduleRepo {
    http: Http;

    constructor(http: Http) {
        this.http = http
    }

    // スケジュール一覧取得
    async getScheduleList(queryString: string): Promise<NatGetScheduleList> {
        return await this.http.get(`/api/common/schedule/?${queryString}`);
    }

    // スケジュール登録
    async postSchedule(request: NatPostScheduleParams): Promise<NatPostSchedule> {
        return await this.http.post(`/api/admin/schedule`, {...request}, ContentType.JSON);
    }

    // スケジュール取得
    async getSchedule(scheduleId: string): Promise<NatGetSchedule> {
        return await this.http.get(`/api/common/schedule/${scheduleId}`);
    }

    // スケジュール更新
    async putSchedule(request: NatPutScheduleParams): Promise<NatPutSchedule> {
        return await this.http.put(`/api/admin/schedule`, request);
    }

    // スケジュール削除
    async deleteScheduler(scheduleId: string): Promise<NatDeleteSchedule> {
        return await this.http.delete(`/api/admin/schedule/${scheduleId}`)
    }

}
